<template>
<div class="chapter">
<div class="inner_page">
<div class="toc">
<a id="title15"><h1 class="title">Table of Contents</h1>
</a><div class="toc_entry"><a id="title15"><br/>
</a><span class="toc_entry_titlePage" href="#/e9781439635360_tp01" title="Link target outside of Sample"><span>Title Page</span></span><br/>
<span class="toc_entry_pubInfo" href="#/e9781439635360_cop01" title="Link target outside of Sample"><span>Copyright Page</span></span><br/>
<span class="toc_entry_dedicationPage" href="#/e9781439635360_ded01" title="Link target outside of Sample"><span>Dedication</span></span><br/>
<a class="toc_entry_acknowPage" href="#/e9781439635360_ack01"><span>ACKNOWLEDGMENTS</span></a><br/>
<a class="toc_entry_frontMatter" href="#/e9781439635360_fm02"><span>INTRODUCTION</span></a><br/>
<span class="toc_entry_chapter" href="#/e9781439635360_c01" title="Link target outside of Sample"><span><em class="i">One</em> - INAUSPICIOUS BEGINNINGS 1794–1840</span></span><br/>
<span class="toc_entry_chapter" href="#/e9781439635360_c02" title="Link target outside of Sample"><span><em class="i">Two</em> - YEARS OF TUMULT AND REORGANIZATION 1840–1879</span></span><br/>
<span class="toc_entry_chapter" href="#/e9781439635360_c03" title="Link target outside of Sample"><span><em class="i">Three</em> - CREATION OF A MODERN UNIVERSITY 1879–1904</span></span><br/>
<span class="toc_entry_chapter" href="#/e9781439635360_c04" title="Link target outside of Sample"><span><em class="i">Four</em> - A PROGRESSIVE UNIVERSITY, 1904–1940</span></span><br/>
<span class="toc_entry_chapter" href="#/e9781439635360_c05" title="Link target outside of Sample"><span><em class="i">Five</em> - EXPANDING HORIZONS 1940–1980</span></span><br/>
<span class="toc_entry_chapter" href="#/e9781439635360_c06" title="Link target outside of Sample"><span><em class="i">Six</em> - PREPARATIONS FOR THE FUTURE 1980–PRESENT</span></span><br/>
<span class="toc_entry_biblio" href="#/e9781439635360_bib01" title="Link target outside of Sample"><span>BIBLIOGRAPHY</span></span><br/>
<span class="toc_entry_index" href="#/e9781439635360_ind01" title="Link target outside of Sample"><span>INDEX</span></span><br/></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9781439635360_toc01.vue?4b7bb0ca